/* El alta de un proveedor del pañol (Depósitos → Proveedor).
 *
 * ── EL NÚMERO LO PONE EL ALTA, NO LA BASE ───────────────────────────────────
 *
 * `proveedores.id` es texto, obligatorio y SIN valor por defecto: la base no
 * numera nada. El formulario no tiene campo de número, así que el alta mandaba
 * la fila sin `id`, la base la rechazaba y el cartel decía «No hemos podido
 * procesar la solicitud» sin nombrar por qué (Nico, 20/10, dando de alta a
 * Wurth: le pasaba con cualquier proveedor nuevo). Los que hay están numerados
 * 1, 2, 3… (el 20/10, del 1 al 96, más un «0X»): el nuevo va con el siguiente.
 *
 * ── EL CUIT, SÓLO DÍGITOS ───────────────────────────────────────────────────
 *
 * Así están guardados los 96 que tienen CUIT. El campo del formulario es de
 * número, y «30-12345678-9» escrito con guiones daba `Number(...)` = NaN, que
 * viaja como vacío: el proveedor quedaba sin CUIT sin que nadie se enterara.
 *
 * Puro: se prueba sin montar React ni tocar la base.
 */

export const cuitDigitos = (valor) => String(valor ?? "").replace(/\D/g, "");

/* El siguiente número libre: el mayor de los que son sólo dígitos, más uno.
 * Lo que no es un número («0X») no cuenta. Sin ninguno, el 1. */
export function siguienteIdProveedor(filas) {
  let mayor = 0;
  for (const f of filas || []) {
    const id = String(f?.id ?? "").trim();
    if (/^\d+$/.test(id)) mayor = Math.max(mayor, Number(id));
  }
  return String(mayor + 1);
}

/* Los proveedores que ya tienen ese CUIT (comparado por dígitos). Vacío no
 * choca con vacío: hay proveedores cargados sin CUIT. */
export function proveedoresConCuit(filas, cuit) {
  const buscado = cuitDigitos(cuit);
  if (!buscado) return [];
  return (filas || []).filter((f) => cuitDigitos(f?.cuit) === buscado);
}

/* El texto del aviso: con QUIÉN choca, para no tener que ir a buscarlo. */
export function textoCuitRepetido(cuit, ya) {
  const quienes = (ya || [])
    .map((f) => `${f.nombre || f.marca || "sin nombre"} (proveedor ${f.id})`)
    .join(", ");
  return `El CUIT ${cuitDigitos(cuit)} ya está cargado: ${quienes}. ¿Lo cargo igual?`;
}
